import React from 'react'
import styled, { keyframes } from 'styled-components'
import LoadingWheel from '../components/loadingWheel/LoadingWheel'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
`

const ComponentWrapper = styled.div`
	width: 100%;
	height: 100%;
`

const exiting = keyframes`
  0% {
    opacity: 1;
  }
  100% {
     opacity: 0;
  }
`

const LoadingLayer = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 1);
	position: absolute;
	top: 0;
	left: 0;
	&.exiting {
		animation: ${exiting} 300ms ease-out;
		animation-fill-mode: forwards;
	}
`

const LoadingWheelContainer = styled.div`
	width: 50px;
	height: 50px;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
`

const withLoading = (Component: any) => {
	//TODO: find a way to avoid using any here
	return class Loading extends React.PureComponent<any> {
		private timeoutId = 0

		constructor(props: any) {
			super(props)

			this.timeoutId = window.setTimeout(() => {
				if (!this.state.isLoaded) {
					this.setState({
						loadingState: 'visible',
					})
				}
			}, 150)
		}

		state = {
			isLoaded: false,
			loadingState: 'hidden',
		}

		onViewLoaded = () => {
			let newLoadingState = 'hidden'
			if (this.state.loadingState === 'visible') {
				newLoadingState = 'exit'
				this.timeoutId = window.setTimeout(() => {
					this.setState({
						loadingState: 'hidden',
					})
				}, 300)
			}
			this.setState({
				isLoaded: true,
				loadingState: newLoadingState,
			})
		}

		render() {
			return (
				<Wrapper>
					<ComponentWrapper style={{ opacity: this.state.isLoaded ? 1 : 0 }}>
						<Component onViewLoaded={this.onViewLoaded} {...(this.props as any)} />
					</ComponentWrapper>
					{this.state.loadingState !== 'hidden' && (
						<LoadingLayer className={this.state.loadingState === 'exit' ? 'exiting' : ''}>
							<LoadingWheelContainer>
								<LoadingWheel />
							</LoadingWheelContainer>
						</LoadingLayer>
					)}
				</Wrapper>
			)
		}

		componentWillUnmount() {
			window.clearTimeout(this.timeoutId)
		}
	}
}

export default withLoading
